import useToast from '@hooks/ui/useToast';
import { useTranslation } from 'react-i18next';

function useCopyShopAddress(address?: string) {
    const { t } = useTranslation('shopLocation');
    const toast = useToast();
    return () => {
        if (window.navigator.clipboard) {
            window.navigator.clipboard.writeText(address || '')
                .then(() => {
                    toast.success(t('toast.addressCopied'));
                }).catch(() => {
                    toast.error(t('toast.notSupported'));
                });
        } else {
            toast.error(t('toast.notSupported'));
        }
    };
}

export default useCopyShopAddress;
